import Vue from 'vue'
import {
  BIcon, BAvatar, BFormSelect, BFormCheckbox, BFormTextarea,
  BFormInput, BFormDatepicker, BFormFile, BProgress, BProgressBar,
  BImgLazy, BButton, BContainer, BRow, BCol,
  BModal, BFormGroup, BFormCheckboxGroup, BDropdown, BDropdownItemButton,
  BCollapse, BBadge, BFormRadioGroup, BFormRadio, BCard,
  BFormInvalidFeedback, BToast, BFormSelectOption, BFormSelectOptionGroup, BImg,
  BFormRow, VBModal,
  BDropdownItem, BDropdownDivider, BDropdownForm, BDropdownText, BDropdownGroup, BDropdownHeader,
  BCardHeader, BCardFooter, BCardBody, BCardTitle, BCardSubTitle, BCardImg, BCardImgLazy, BCardText, BCardGroup,
  BForm, BFormText, BFormValidFeedback, BFormDatalist,
  BToaster, BFormTimepicker
} from 'bootstrap-vue'
import {
  BIconCheck2, BIconXCircleFill, BIconPinAngleFill, BIconPlusCircleFill,
  BIconTriangleFill, BIconX
} from 'bootstrap-vue'

import { BVToastPlugin, BVModalPlugin
} from 'bootstrap-vue'

// 軽量化のためbootstrap-vueのコンポーネントは使うものだけ指定する
Vue.component('b-icon', BIcon)
Vue.component('b-avatar', BAvatar)
Vue.component('b-form-select', BFormSelect)
Vue.component('b-form-select-option', BFormSelectOption)
Vue.component('b-form-select-option-group', BFormSelectOptionGroup)
Vue.component('b-form-checkbox', BFormCheckbox)
Vue.component('b-form-textarea', BFormTextarea)
Vue.component('b-form-input', BFormInput)
Vue.component('b-form-datepicker', BFormDatepicker)
Vue.component('b-form-file', BFormFile)
Vue.component('b-progress', BProgress)
Vue.component('b-progress-bar', BProgressBar)
Vue.component('b-img-lazy', BImgLazy)
Vue.component('b-img', BImg)
Vue.component('b-button', BButton)
Vue.component('b-container', BContainer)
Vue.component('b-row', BRow)
Vue.component('b-col', BCol)
Vue.component('b-form-row', BFormRow)
Vue.component('b-modal', BModal)
Vue.component('v-b-modal', VBModal)
Vue.component('b-form-group', BFormGroup)
Vue.component('b-form-checkbox-group', BFormCheckboxGroup)
Vue.component('b-dropdown', BDropdown)
Vue.component('b-dropdown-item', BDropdownItem)
Vue.component('b-dropdown-divider', BDropdownDivider)
Vue.component('b-dropdown-form', BDropdownForm)
Vue.component('b-dropdown-text', BDropdownText)
Vue.component('b-dropdown-group', BDropdownGroup)
Vue.component('b-dropdown-header', BDropdownHeader)
Vue.component('b-dropdown-item-button', BDropdownItemButton)
Vue.component('b-collapse', BCollapse)
Vue.component('b-badge', BBadge)
Vue.component('b-form-radio-group', BFormRadioGroup)
Vue.component('b-form-radio', BFormRadio)
Vue.component('b-card', BCard)
Vue.component('b-card-header', BCardHeader)
Vue.component('b-card-footer', BCardFooter)
Vue.component('b-card-body', BCardBody)
Vue.component('b-card-title', BCardTitle)
Vue.component('b-card-sub-title', BCardSubTitle)
Vue.component('b-card-img', BCardImg)
Vue.component('b-card-img-lazy', BCardImgLazy)
Vue.component('b-card-text', BCardText)
Vue.component('b-card-group', BCardGroup)
Vue.component('b-form-invalid-feedback', BFormInvalidFeedback)
Vue.component('b-form', BForm)
Vue.component('b-form-text', BFormText)
Vue.component('b-form-valid-feedback', BFormValidFeedback)
Vue.component('b-form-datalist', BFormDatalist)
Vue.component('b-toast', BToast)
Vue.component('b-toaster', BToaster)
Vue.component('b-form-timepicker', BFormTimepicker)

// 必要なアイコンのみ指定
Vue.component('b-icon-check2', BIconCheck2)
Vue.component('b-icon-x-circle-fill', BIconXCircleFill)
Vue.component('b-icon-pin-angle-fill', BIconPinAngleFill)
Vue.component('b-icon-plus-circle-fill', BIconPlusCircleFill)
Vue.component('b-icon-triangle-fill', BIconTriangleFill)
Vue.component('b-icon-x', BIconX)

// プラグインの登録 $bvToastを使えるようにする
Vue.use(BVToastPlugin)
Vue.use(BVModalPlugin)